module.exports = __webpack_public_path__ + "static/scale-model-of-giant-globe-in-long-beach-california-310bdb496ec274ce6eede8f31b2920de.png";